import { createSlice } from '@reduxjs/toolkit';
import { USER_TYPES } from '@sv-support-sdk/utils/src/constants/chat';
import { resetState } from '@sv-support-sdk/chat-store/src/modules/reset/actions';

interface IUserState {
  id: string;
  email: string;
  workspaceId: string;
  type: string;
  emailAsked: boolean;
  uuid: string;
}

const initialState = {
  id: '',
  email: 'Customer',
  workspaceId: '',
  type: USER_TYPES.UNREGISTERED,
  emailAsked: false,
  uuid: '',
} as IUserState;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state: IUserState, action) => ({
      ...state,
      ...action.payload,
      isLoaded: true,
    }),
    resetUser: () => ({
      ...initialState,
      isLoaded: true,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(resetState, () => {
      return initialState;
    });
  },
});

export const { updateUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
